import React, { createContext, useEffect, useState } from "react";
import { getEmployeeTCPRolesWithRootStations } from "../resources/EmployeeResource";
import {
  SETTINGSV2_PERMISSIONS_REGION,
  SCC_SETTINGS_MANAGER,
  ROOT_STATIONS,
  SCC_SETTINGS_MANAGER_STATION_LEVEL,
} from "../util/Constants";
import Loader from "../loader/Loader";
import { getRegion } from "../util/Util";
import { getStationCode } from "../network/NetworkUtil";

export const PermissionsContext = createContext();

const isValidTcpRole = (tcpRoles) => {
  if (tcpRoles) {
    return SCC_SETTINGS_MANAGER.some((manager) =>
      tcpRoles.some((role) => role.includes(manager)),
    );
  }
  return false;
};

const isValidTcpRoleStationLevel = (tcpRoles) => {
  if (tcpRoles) {
    return SCC_SETTINGS_MANAGER_STATION_LEVEL.some((manager) =>
      tcpRoles.some((role) => role.includes(manager)),
    );
  }
  return false;
};

const isValidRootStation = (tcpStations, region) => {
  if (tcpStations && ROOT_STATIONS[region]) {
    return ROOT_STATIONS[region].some((rootStation) =>
      tcpStations.includes(rootStation),
    );
  }
  return false;
};

const isValidUserForSettingsv2EditAccess = (
  tcpRolesWithRootStations,
  region,
) => {
  if (tcpRolesWithRootStations && region) {
    region = region.toUpperCase();
    let stations = Object.keys(tcpRolesWithRootStations);
    if (isValidRootStation(stations, region)) {
      let rootStations = ROOT_STATIONS[region];
      const uniqueRoles = new Set();
      rootStations.forEach((station) => {
        const roles = tcpRolesWithRootStations[station];
        if (roles) {
          roles.forEach((role) => {
            uniqueRoles.add(role);
          });
        }
      });
      if (uniqueRoles) {
        return isValidTcpRole([...uniqueRoles]);
      }
    }
    return false;
  }
  return false;
};

const isValidUserForSettingsv2EditAccessStationLevel = (
  tcpRolesWithRootStations,
) => {
  if (tcpRolesWithRootStations) {
    const stationCode = getStationCode();
    if (tcpRolesWithRootStations[stationCode]) {
      return isValidTcpRoleStationLevel(tcpRolesWithRootStations[stationCode]);
    }
  }
  return false;
};

const PermissionsContextProvider = ({ children }) => {
  const [isUserAuthorisedForSettingsEdit, setIsUserAuthorisedForSettingsEdit] =
    useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const tcpRolesWithRootStationsResponse =
        await getEmployeeTCPRolesWithRootStations();

      const region = getRegion();

      let isAuthorizedOnRootLevel = isValidUserForSettingsv2EditAccess(
        tcpRolesWithRootStationsResponse,
        region,
      );

      let isAuthorizedOnSiteLevel =
        isValidUserForSettingsv2EditAccessStationLevel(
          tcpRolesWithRootStationsResponse,
        );

      let isAuthorized =
        isAuthorizedOnRootLevel ||
        isAuthorizedOnSiteLevel ||
        !SETTINGSV2_PERMISSIONS_REGION.includes(region);

      setIsUserAuthorisedForSettingsEdit(isAuthorized);
      setIsLoading(false);
    })();
  }, []);
  if (isLoading) return <Loader />;
  return (
    <PermissionsContext.Provider value={{ isUserAuthorisedForSettingsEdit }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export default PermissionsContextProvider;



// WEBPACK FOOTER //
// ./src/components/permissions/PermissionsContext.js